import { EmailAttachment, EmailAttachmentJson } from '@models/email-attachment';
import { EmailBase } from '@models/email-base';

export interface EmailJson {
  from: string;
  to: string[];
  cc: string[];
  cci: string[];
  subject: string;
  body: string;
  attachments: Partial<EmailAttachmentJson>[];
  reply_to?: string;
}

export class Email extends EmailBase {
  constructor(
    from?: string,
    to?: string[],
    cc?: string[],
    cci?: string[],
    subject?: string,
    body?: string,
    attachments?: EmailAttachment[],
    public replyTo?: string
  ) {
    super(from, to, cc, cci, subject, body, attachments);
  }

  static fromJson(json: Partial<EmailJson>): Email {
    return new Email(
      json.from,
      json.to ? json.to : [],
      json.cc ? json.cc : [],
      json.cci ? json.cci : [],
      json.subject,
      json.body,
      json.attachments
        ? json.attachments.map((attachmentJson: EmailAttachmentJson) => EmailAttachment.fromJson(attachmentJson))
        : [],
      json.reply_to
    );
  }

  static toJson(email: Email): EmailJson {
    return {
      from: email.from,
      to: email.to,
      cc: email.cc,
      cci: email.cci,
      subject: email.subject,
      body: email.body,
      attachments: email.attachments
        ? email.attachments.map(emailAttachment => EmailAttachment.toJson(emailAttachment))
        : [],
      reply_to: email.replyTo
    };
  }
}
